import { dispatchFirehoseJsonMessage } from './routing/dispatch-firehose-message.js';
import { tryConsumeBinaryProxyBody } from './routing/try-consume-binary-proxy-body.js';
import type { FirehoseMessageDeps } from './routing/firehose-message-deps.js';

/**
 * Route one inbound WebSocket frame. Proxy control messages run synchronously so metadata
 * is registered before any trailing binary body frame on the same socket.
 */
export function handleInboundFirehoseFrame(raw: Buffer | string, deps: FirehoseMessageDeps): void {
  if (Buffer.isBuffer(raw) && tryConsumeBinaryProxyBody(raw, deps)) {
    return;
  }

  let msg: Record<string, unknown>;
  try {
    const text = Buffer.isBuffer(raw) ? raw.toString('utf8') : String(raw);
    msg = JSON.parse(text) as Record<string, unknown>;
  } catch {
    return;
  }

  if (msg.type === 'proxy') {
    dispatchFirehoseJsonMessage(msg, deps);
    return;
  }

  setImmediate(() => {
    dispatchFirehoseJsonMessage(msg, deps);
  });
}
